<template>

<ion-app>
  <ion-split-pane content-id="main-content">
    <ion-router-outlet id="main-content">
    </ion-router-outlet>
  </ion-split-pane>
  <MainMenu v-if="state.menu_allowed === true" />
  <ion-alert
  :isOpen="isOpen"
    header="TouchPoints"
    message="Your diary has been reset, please relogin to continue"
    backdropDismiss="false"
    :buttons="alertButtons"
    @didDismiss="setOpen(false)"
  >
  </ion-alert>
  <ion-alert
  :isOpen="appStatus.showMultipleSessionTabsError"
    header="TouchPoints"
    :message="multipleSessionTabsMessage"
    backdropDismiss="false"
    :buttons="multipleSessionButtons"
    @didDismiss="appStatus.showMultipleSessionTabsError = false"
  >
  </ion-alert>
</ion-app>

</template>

<script setup lang="ts">
/*
  imports
*/
import { IonApp, IonRouterOutlet, IonSplitPane, IonAlert } from '@ionic/vue';
import "@fortawesome/fontawesome-free/css/solid.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import MainMenu from './components/MainMenu/MainMenu.vue';
import { useRoute, useRouter } from 'vue-router';
import { reactive, ref, watch, onMounted, onUnmounted } from 'vue';
import { check_for_reset_user, useTouchpointsHTTP } from './use/useTouchpointsHTTP';
import getDevice from './use/useGetDeviceInfo';
import { appStatus } from "./use/useAppStatus";

import { usePushNotificationReceiver } from './use/usePushNotificationReceiver';

import { useRequestQueue } from '@/use/useRequestQueue';

/* Request queue */
onMounted(() => {
  appStatus.requestQueue = useRequestQueue();
  appStatus.requestQueue.start();
});

onUnmounted(() => {
  appStatus.requestQueue.stop();
});



const multipleSessionTabsMessage = "You’ve already got the diary opened in another tab. Please close the other tab to continue.";

localStorage.openpages = Date.now();

window.addEventListener('storage', function (e) {
    if(e.key == "openpages") {
        // Listen if anybody else is opening the same page!
        localStorage.page_available = Date.now();
    }
    if(e.key == "page_available") {
      console.log("One more page already open");
      appStatus.showMultipleSessionTabsError = true;
    }
}, false);

if(localStorage.getItem("session_id") === null || localStorage.getItem("session_id") === undefined) {
  if(localStorage.getItem("userId") && localStorage.getItem("userId")!.trim() !== "") {
    localStorage.setItem("session_id", Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
  }
}

if(appStatus.showMultipleSessionTabsError) {
  console.log("Show tabs alert")
}

const {updateDiaryLastAccessTime} = useTouchpointsHTTP();

const blocked_urls = ['/onboarding', '/termsandconditions', '/privacy', '/training', '/login', '/welcome', '/question', '/contactsupport', '/notifications', '/sleeptask' , '/adhoc'];

const route = useRoute();
// eslint-disable-next-line
const router = useRouter();
const usePushNotification = usePushNotificationReceiver();

const initial_menu_state = blocked_urls.filter((path) => path === route.path)[0] === undefined ? true : false;

const state = reactive({
  path: route.path,
  menu_allowed: initial_menu_state
});


if(localStorage.getItem("username")) {
  const deviceInfo = getDevice(navigator.userAgent, localStorage.getItem("username")!);
  useTouchpointsHTTP().saveDevice(deviceInfo!);
}

window.addEventListener('popstate', (e) => {
  e.preventDefault();
  setTimeout(() => {
    window.location.reload();
  }, 200);
});

function logOut() {
  window.localStorage.removeItem("userId")
  window.localStorage.removeItem("touchPointsLastLogin")
  window.localStorage.removeItem("username")
  window.localStorage.removeItem("touchPointsAuth")
  window.localStorage.removeItem("diaryStartDate")
  window.localStorage.removeItem("privacyAgree")
  window.localStorage.removeItem("trainingAgree")
  window.localStorage.removeItem("sleepTaskAgree")
  window.localStorage.removeItem("termAgree")
  window.localStorage.removeItem("dummyTimeslot")
  window.localStorage.removeItem("diaryId")
  window.localStorage.removeItem("session_id");
  setTimeout(() => {
    location.reload();
    router.push({name: 'login'});
  }, 100); 
}

const isOpen = ref(false);
const setOpen = (state: boolean) => {
  isOpen.value = state;
};

const alertButtons = [{
          text: 'Logout',
          handler: () => {
            logOut();
            localStorage.setItem("checked_for_reset", "true");
          },
        },
      ];

const multipleSessionButtons = [
  {
    text: 'Understood',
    handler: () => {
      window.location.reload()
    },
  },
]

if(localStorage.getItem('username')) {

  useTouchpointsHTTP().getDiary(localStorage.getItem("username")!)
  .then((response: any) => {
    const currentDate = new Date();
    const diaryDate = new Date(response.data.first_day_time);
    // update diary ID
    localStorage.setItem("diaryId", `${response.data.id}`)
    //console.log(diaryDate)
    if (currentDate >= diaryDate) {
      updateDiaryLastAccessTime(localStorage.getItem('username')!);
    } else {
      router.push("/onboarding")
    }
  })

  check_for_reset_user(localStorage.getItem("username")!)
  .then((response) => {
    const check_for_reset = response.check_for_reset;
    if(check_for_reset) {
      if(localStorage.getItem("checked_for_reset") !== "true" && localStorage.getItem("checked_for_reset") !== "false") {
        localStorage.setItem("checked_for_reset", "false");
        setOpen(true);
      }
      if(localStorage.getItem("checked_for_reset") === "false") {
        setOpen(true);
      }
      if(localStorage.getItem("checked_for_reset") === "true") {
        useTouchpointsHTTP().getDiary(localStorage.getItem("username")!)
        .then((response: any) => {
          //console.log(response.data)
          const localDiaryId = localStorage.getItem("diaryId");
          const currentDiaryId = response.data.id;

          if(Number(localDiaryId) !== currentDiaryId) {
            localStorage.setItem("checked_for_reset", "false");
            setOpen(true);
          }
        })
        //console.log("check diary")
      }
    }
  })
}
/* //[debug commnet out reopen when live]
if ('serviceWorker' in navigator) {
    console.log('Service Worker is supported in this browser.');
    // You can register your Service Worker here
} else {
  alert("Service Worker is not supported in this browser.");
  window.location.replace("error.html");
}
*/

// Add the serviceWorker message event listener
navigator.serviceWorker.addEventListener('message', usePushNotification.onHandleMessageEvent);

watch(route, (newRoute) => {
  state.path = newRoute.path;
  const found_url = blocked_urls.filter((path) => path === newRoute.path);
  if(found_url[0] ) {
    state.menu_allowed = false;
  }
  else {
    state.menu_allowed = true
  }
})

</script>

<style>
/*
  import Karla font
*/
ion-content, ion-header, ion-footer{
  font-family: Karla, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  --color: #2c3e50;
}

@font-face {
  font-family: "Karla";
  src: local("Karla"),
   url(./fonts/Karla/Karla-VariableFont_wght.ttf) format("truetype");
   font-display: swap; /* [Improve implement] loading */
}


.SmallFont{
  font-family: Karla, sans-serif;
  font-size: 14px;
  --color: #4A4A49;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.48px;
}

.StandardFont{
  font-family: Karla, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  --color: #4A4A49;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.48px;
}

.MediumFont{
  font-family: Karla, sans-serif;
  font-size: 20px;
  line-height: normal;
  --color: #4A4A49;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.LargeFont{
  font-family: Karla, sans-serif;
  font-size: 24px;
  line-height: normal;
  --color: #4A4A49;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/*
  remove dragging on mobile
*/


* {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: -moz-none;
    -o-user-select: none;
    user-select: none;
}

p {
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -o-user-select: text;
    user-select: text;
}
</style>